import { StringMap } from '@/shared/utils/map'

export interface Filter {
  canReset: boolean
  categories: StringMap<boolean>
  filterHasChanged: boolean
  term?: string
  queryHasChanged: boolean
}

export function defaultFilter(): Filter {
  return {
    canReset: false,
    categories: {},
    filterHasChanged: false,
    term: undefined,
    queryHasChanged: false,
  }
}
